<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/evaluator/maintenance/storeDetail/${inputs.id}`
            : `/evaluator/maintenance/storeDetail`
        "
      >
        <div class="row" v-if="show">
          <div class="col-md-6">
            <div class="form-group">
              <label>Codigo</label>
              <app-input
                type="text"
                v-model="inputs.code"
                placeholder="Ingrese el codigo"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Cargo/Función</label>
              <app-input
                type="text"
                v-model="inputs.function"
                placeholder="Ingrese el cargo o función"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Tipo de evaluador</label>
              <app-input
                type="select"
                v-model="inputs.type_id"
                :required="true"
                :list="evaluatorType"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label> Area </label>
              <app-input
                type="select"
                v-model="inputs.area_id"
                :list="accreditationAreaList"
                v-on:change="onChangeAccreditationArea"
                :required="true"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.type_id != 6">
            <div class="form-group">
              <label v-if="inputs.type_id != 6"> Esquema </label>
              <app-input
                type="select"
                v-model="inputs.activity_id"
                :list="accreditationActivityList"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.type_id == 6">
            <div class="form-group">
              <label> Sector </label>
              <app-input
                type="select"
                v-model="inputs.sector_id"
                :list="accreditationScopesList"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.type_id != 6">
            <div class="form-group">
              <label> Norma </label>
              <app-input
                type="select"
                v-model="inputs.rule_id"
                :list="accreditationRuleList"
              />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.type_id == 6">
            <div class="form-group">
              <label> ALCANCE EN EL QUE SE ENCUENTRA CALIFICADO </label>
              <app-input
                type="select"
                v-model="inputs.scope_id"
                :list="accreditationScopeEvalList"
              />
            </div>
          </div>
        </div>

        <div class="row" v-if="show">
          <div class="col-md-6">
            <div class="form-group">
              <label>Estatus</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_active"
                :list="isActive"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Fecha de habilitación</label>
              <app-input type="text" v-model="inputs.enable_date" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Actualización de calificación</label>
              <app-input type="text" v-model="inputs.rating_update" />
            </div>
          </div>

          <div class="col-md-6" v-if="inputs.type_id == 6">
            <div class="form-group">
              <label>CÓDIGO IAF/SUBCATEGORIA ALIMENTARIA (DC)</label>
              <app-input type="text" v-model="inputs.iaf_code" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Fecha de actualización de documentos</label>
              <app-input
                type="text"
                v-model="inputs.documentation_update_date"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Ultima evaluación de desempeño</label>
              <app-input type="text" v-model="inputs.last_evaluation" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Fecha para la siguiente evaluación</label>
              <app-input type="text" v-model="inputs.next_evaluation" />
            </div>
          </div>

          <div class="col-md-6" v-if="validity">
            <div class="form-group">
              <label>Vigencia</label>
              <app-input type="text" v-model="validity" disabled />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Resultado de la evaluación</label>
              <app-input type="text" v-model="inputs.evaluation_result" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Evaluación de desempeño baja ( menor a 3)</label>
              <app-input
                type="text"
                v-model="inputs.performance_evaluation_low"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Parametro evaluación de desempeño baja (menor a 3)</label>
              <app-input type="text" v-model="inputs.performance_parameter" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Evaluación de desempeño planificada</label>
              <app-input
                type="text"
                v-model="inputs.performance_planification_eval"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import * as actions from "../../apiURL";
import { axiosGet } from "../../../../../../../resources/js/app/helpers/AxiosHelper";
import moment from "moment";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        is_active: 0,
        evaluator_id: localStorage.getItem("evaluator_id"),
      },
      modalId: "config-modal-add-edit",
      scope: [
        { id: null, value: this.$t("select_option") },
        {
          id: "O",
          value: "SAE",
        },
        {
          id: "E",
          value: "Externo",
        },
      ],
      typeInstitution: [
        { id: null, value: this.$t("select_option") },
        {
          id: "PU",
          value: "Publica",
        },
        {
          id: "PR",
          value: "Privada",
        },
      ],
      isActive: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
      delayTimer: null,
      show: true,
      counter: "",
      provinceList: [],
      cantonList: [],
      accreditationActivityLists: [{ id: "", value: this.$t("select_option") }],
      evaluatorType: [],
      accreditationAreaList: [],
      accreditationActivityList: [],
      accreditationRuleList: [],
      accreditationScopesList: [],
      accreditationScopeEvalList: [],
      validity: "",
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
    /* evaluatorType() {
      return [
        { id: null, value: this.$t("select_option") },
        ...this.$store.state.evaluatorReview.evaluatorType,
      ];
    }, */
    cantons() {
      return [
        { id: null, value: this.$t("select_option") },
        ...this.$store.state.common.cantons,
      ];
    },
    // accreditationAreaList() {
    //   let uri = `/accreditations/applications/options`;
    //   axiosGet(uri).then((response) => {
    //     return [
    //       { id: "", value: "Selecciona una opción" },
    //       ...response.data.accreditationAreas,
    //     ];
    //   });
    // },
    /* accreditationActivityList() {
      return [
        { id: "", value: "Selecciona una opción" },
        ...this.$store.state.accreditation.accAppOptions
          .accreditationActivities,
      ];
    }, */
  },
  watch: {
    "inputs.country_id": function () {
      this.provinceList = this.$store.getters.getProvinces(
        this.inputs.country_id
      );
    },

    "inputs.province_id": function () {
      this.cantonList = this.$store.getters.getCantons(this.inputs.province_id);
    },

    "$store.state.common.countries": function () {
      if (this.inputs.i_country_id) {
        this.provinceList = this.$store.getters.getProvinces(
          this.inputs.i_country_id
        );
        this.cantonList = this.$store.getters.getCantons(
          this.inputs.org.i_province_id
        );
      }
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
      this.show = true;
    }
    this.types();
    this.validateVigence();
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    validateVigence() {
      var estado;
      if (this.selectedUrl) {
        let last_evaluation = moment(this.inputs.last_evaluation).format(
          "YYYY-MM-DD"
        );
        let next_evaluation = moment(this.inputs.next_evaluation).format(
          "YYYY-MM-DD"
        );
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }
        if (mm < 10) {
          mm = "0" + mm;
        }
        var today = yyyy + "-" + mm + "-" + dd;
        if (last_evaluation) {
          if (today >= last_evaluation && today <= next_evaluation) {
            estado = "Vigente";
          } else {
            estado = "Incativo";
          }
        }
        this.validity = estado;
      }
    },

    types() {
      let url = `${actions.EVALUATOR_MAINTENANCE}/types`;
      axiosGet(url).then((response) => {
        this.evaluatorType = [
          { id: null, value: this.$t("select_option") },
          ...response.data,
        ];
      });

      let uri = `/accreditations/applications/options`;
      axiosGet(uri).then((response) => {
        this.accreditationAreaList = [
          { id: "", value: "Selecciona una opción" },
          ...response.data.accreditationAreas,
        ];

        this.accreditationActivityList = [
          { id: "", value: "Selecciona una opción" },
          ...response.data.accreditationActivities,
        ];
      });

      let urlRules = `/rules`;
      axiosGet(urlRules).then((response) => {
        this.accreditationRuleList = [
          { id: null, value: this.$t("select_option") },
          ...response.data.rules,
        ];

        this.accreditationScopesList = [
          { id: null, value: this.$t("select_option") },
          ...response.data.sector,
        ];

        this.accreditationScopeEvalList = [
          { id: null, value: this.$t("select_option") },
          ...response.data.eval_scopes,
        ];
      });
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.preloader = false;
      const { data } = response;
      this.inputs = data;
      this.onChangeAccreditationArea();
    },

    onChangeAccreditationArea() {
      this.accreditationActivityLists = [
        { id: "", value: this.$t("select_option") },
        ...this.accreditationActivityList.filter((item) => {
          return item.parent == this.inputs.area_id;
        }),
      ];
    },

    onKeyUpTaxid() {
      this.counter = this.inputs.taxid.length;
      if (this.inputs.taxid.length == 10 || this.inputs.taxid.length == 13) {
        if (this.inputs.taxid != null && !this.inputs.id) {
          clearTimeout(this.delayTimer);
          this.delayTimer = setTimeout(this.ckeckTaxid, 1000);
        }
      }
    },

    handleBlur(e) {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckTaxid, 1000);
      }
    },

    ckeckTaxid() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?taxid=${this.inputs.taxid}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            const { data } = response;
            this.show = true;
            if (data) {
              const tmp = {
                user_id: data.id,
                first_name: data.first_name,
                last_name: data.last_name,
                phone: data.phone,
                email: data.email,
              };
              this.inputs = {
                ...this.inputs,
                ...tmp,
              };
            }
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    onKeyUpUsername() {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckUsername, 1000);
      }
    },
    ckeckUsername() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?username=${this.inputs.username}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.uniqueUsername = response.data == "";
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    onKeyUpEmail() {
      if (this.inputs.taxid != null && !this.inputs.id) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(this.ckeckEmail, 1000);
      }
    },
    ckeckEmail() {
      this.preloader = true;
      clearTimeout(this.delayTimer);
      const url = `/evaluator/maintenance/user?email=${this.inputs.email}`;
      this.axiosGet(url)
        .then((response) => {
          if (response.status == 200) {
            this.uniqueEmail = response.data == "";
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
};
</script>
